import React, { Fragment, useEffect, useState } from "react";
import Link from "react-router-dom/Link";
import NavLink from "react-router-dom/NavLink";
import $ from "jquery";
import AsideInfo from "./AsideInfo";
import store from "../../common/store";
import { getAdmin, isEmpty, toastr } from "../../common/cores";
import { headLogout } from "../../utils";
import connect from "react-redux/lib/connect/connect";
import { logoutUser } from "../../common/actions/userActions";
import { SetShowLeft } from "../../common/actions/userActions";

const roomObj = {
  pageType: "other",
  RoomType: "other",
  sportType: "other",
  gameType: "other"
};

const roomData = {
  MessageType: "RoomType",
  data: roomObj
};

const premenus1 = [
  // {
  //   name: "스포츠",
  //   name_en: "SPORTS",
  //   path: "/sportsprematch",
  //   showImg: true,
  //   notready: false,
  //   value: "sport_prematch"
  // },
  // {
  //   name: "라이브",
  //   name_en: "SPORTS LIVE",
  //   path: "/sportslive",
  //   showImg: true,
  //   notready: false,
  //   value: "sport_live"
  // },
  // {
  //   name: "E-스포츠",
  //   name_en: "E-SPORTS",
  //   path: "/esports",
  //   showImg: true,
  //   notready: false,
  //   value: "esport_prematch"
  // },
  {
    name: "카지노",
    name_en: "CASINO",
    path: "/casino",
    showImg: true,
    notready: false,
    value: "casino"
  },
  // {
  //   name: "호텔카지노",
  //   name_en: "HOTEL CASINO",
  //   path: "/hotelcasino",
  //   showImg: true
  // },
  {
    name: "슬롯",
    name_en: "SLOT",
    path: "/slot",
    showImg: true,
    notready: false,
    value: "slot"
  },
  // {
  //   name: "미니게임",
  //   name_en: "MINI GAME",
  //   path: "/minigame",
  //   showImg: true,
  //   notready: false,
  //   value: "minigame"
  // },
  // {
  //   name: "벳365",
  //   name_en: "BET365GAME",
  //   path: "/betgame",
  //   showImg: false,
  //   notready: false,
  //   value: "betgame"
  // }
];
const menus2 = [
  {
    name: "충전",
    name_en: "",
    path: "/deposit"
  },
  {
    name: "환전",
    name_en: "",
    path: "/withdraw"
  },
  {
    name: "공지사항",
    name_en: "",
    path: "/notices"
  },
  {
    name: "이벤트",
    name_en: "",
    path: "/events"
  },
  {
    name: "고객센터",
    name_en: "",
    path: "/inquiries/question"
  },
  {
    name: "마이페이지",
    name_en: "",
    path: "/myPage/history"
  }
];

const Headbar = (props) => {

    const { isAuthenticated, gameCheck, user } = props
    

  const [aside1, setAside1] = useState(false);
  const [aside2, setAside2] = useState(false);
  const [popup, setPopup] = useState(false);

  const openAside1 = () => {
    setAside1(!aside1);
  };
  const openAside2 = () => {
    setAside2(!aside2);
  };

  const onPopup = () => {
    setPopup(!popup);
  }

  const onLogout = () => {
    props.logoutUser();
    onPopup();
  }

  const onPath = val => {
    if(window.ws.readyState === 1){
      window.ws.send(JSON.stringify(roomData));
    }
  };

  const view = () => {
    props.SetShowLeft(!user.showleft)
  }

  let menus1 = premenus1;

  for (let x in gameCheck) {
    for (let y in menus1) {
      if (x === menus1[y].value) {
        menus1[y].notready = gameCheck[x];
      }
    }
  }

  const MLmenu = (menu, index) => {
    if (isAuthenticated){
      if(menu.notready && user.role < 4){
        return (
          <tr key={index}>
          <td>
            <Link
              to={menu.path}
              onClick={e => {
                e.preventDefault();
                toastr.warning("점검중입니다.")
                openAside1();
              }}
            >
              <span className="aside_btn3">
                <img src="../images/m_icon03.png" width="28px" alt="" />
                &nbsp;{menu.name} <span>{menu.name_en}</span>
              </span>
            </Link>
          </td>
        </tr>
        );
      }
      else{
        return (
          <tr key={index}>
            <td>
              <Link to={menu.path} onClick={() => { openAside1(); onPath(menu.path);}}>
                <span className="aside_btn3">
                  <img src="../images/m_icon03.png" width="28px" alt="" />
                  &nbsp;{menu.name} <span>{menu.name_en}</span>
                </span>
              </Link>
            </td>
          </tr>
        );
      }
    }
    else
      return (
        <tr key={index}>
          <td>
            <Link
              to={menu.path}
              onClick={e => {
                e.preventDefault();
                toastr.warning("로그인하시고 이용해주세요.")
                openAside1();
              }}
            >
              <span className="aside_btn3">
                <img src="../images/m_icon03.png" width="28px" alt="" />
                &nbsp;{menu.name} <span>{menu.name_en}</span>
              </span>
            </Link>
          </td>
        </tr>
      );
  };

  const MRmenu = (path, name) => {
    if (isAuthenticated){
        return (
          <td width="10%" align="center">
            <Link to={path} onClick={() => { openAside2(); onPath(path);}}>
              <span className="aside_btn1">{name}</span>
            </Link>
          </td>
        );
    }
    else{
      return (
        <td width="10%" align="center">
          <Link
            to={path}
            onClick={e => {
              e.preventDefault();
              toastr.warning("로그인하시고 이용해주세요.")
              openAside2();
            }}
          >
            <span className="aside_btn1">{name}</span>
          </Link>
        </td>
      );
    }
  };

  const PCLmenu = (menu, index) => {
    if (isAuthenticated){
      if(menu.notready && user.role < 4){
        return (
          <Fragment key={index}>
            <li className="header_menu">
              <NavLink
                className="navLink"
                activeClassName="activeNavLink"
                to={menu.path}
                onClick={e => {
                  e.preventDefault();
                  toastr.warning("점검중입니다.")
                }}
              >
                {menu.name}
                <span>{menu.name_en}</span>
              </NavLink>
            </li>
            {menu.showImg && (
              <li>
                <img src="images/line.jpg" alt="" />
              </li>
            )}
          </Fragment>
        );
      }
      else{
        return (
          <Fragment key={index}>
            <li className="header_menu">
              <NavLink
                className="navLink"
                activeClassName="activeNavLink"
                to={menu.path}
                onClick={() => onPath(menu.path)}
              >
                {menu.name}
                <span>{menu.name_en}</span>
              </NavLink>
            </li>
            {menu.showImg && (
              <li>
                <img src="images/line.jpg" alt="" />
              </li>
            )}
          </Fragment>
        );
      }
    }
    else
      return (
        <Fragment key={index}>
          <li className="header_menu">
            <NavLink
              className="navLink"
              activeClassName="activeNavLink"
              to={menu.path}
              onClick={e => {
                e.preventDefault();
                toastr.warning("로그인하시고 이용해주세요.")
              }}
            >
              {menu.name}
              <span>{menu.name_en}</span>
            </NavLink>
          </li>
          {menu.showImg && (
            <li>
              <img src="images/line.jpg" alt="" />
            </li>
          )}
        </Fragment>
      );
  };

  const PCRmenu = (menu, index) => {
    if (isAuthenticated)
      return (
        <li key={index}>
          <NavLink
            className="navLink"
            activeClassName="activeNavLink"
            to={menu.path} 
            onClick={() => onPath(menu.path)}
          >
            {menu.name}
          </NavLink>
        </li>
      );
    else
      return (
        <li key={index}>
          <NavLink
            className="navLink"
            activeClassName="activeNavLink"
            to={menu.path}
            onClick={e => {
              e.preventDefault();
              toastr.warning("로그인하시고 이용해주세요.")
            }}
          >
            {menu.name}
          </NavLink>
        </li>
      );
  };

  return (
    <Fragment>
      {/* <!-- 좌측메뉴 --> */}
      <div className={`aside ${aside1 && "in"}`}>
        <div className="aside_wrap">
          <div className="aside_top_wrap">
            <div className="aside_top_left">
              <img src="../images/logo.png" width="120" alt="" />
            </div>
            <div
              data-dismiss="aside"
              className="aside_top_right"
              onClick={openAside1}
            >
              <img src="../images/m_close.png" width="50" alt="" />
            </div>
          </div>
          <div className="aside2_box3_wrap">
            <div className="aside2_box2">
              <table
                width="100%"
                border="0"
                align="center"
                cellSpacing="4"
                cellPadding="0"
              >
                <tbody>
                  {menus1.map((menu, index) => {
                    return MLmenu(menu, index);
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- 우측메뉴 --> */}
      <div className={`aside2 ${aside2 && "in"}`}>
        <div className="aside_wrap">
          <div className="aside_top_wrap">
            <div className="aside_top_left">
              <img src="../images/logo.png" width="120" alt="" />
            </div>
            <div
              data-dismiss="aside"
              className="aside_top_right"
              onClick={openAside2}
            >
              <img src="../images/m_close.png" width="50" alt="" />
            </div>
          </div>
          <AsideInfo openAside2={openAside2} />
          <div className="aside2_box2_wrap">
            <div className="aside2_box2">
              <table
                width="100%"
                border="0"
                align="center"
                cellSpacing="4"
                cellPadding="0"
              >
                <tbody>
                  <tr>
                    {MRmenu("/deposit", "충전신청")}
                    {MRmenu("/withdraw", "환전신청")}
                  </tr>
                  <tr>
                    {MRmenu("/deposit/details", "충전내역")}
                    {MRmenu("/withdraw/details", "환전내역")}
                  </tr>
                  <tr>
                    {MRmenu("/notices", "공지사항")}
                    {MRmenu("/inquiries/question", "고객센터")}
                  </tr>
                  <tr>
                    {MRmenu("/events", "이벤트")}
                    {MRmenu("/point", "포인트전환")}
                  </tr>
                </tbody>
              </table>
              <div className="aside2_box2_title">마이페이지</div>
              <table
                width="100%"
                border="0"
                align="center"
                cellSpacing="4"
                cellPadding="0"
              >
                <tbody>
                  <tr>
                    {MRmenu("/myPage/history", "베팅내역")}
                    {MRmenu("/myPage/depositHistory", "충/환전내역")}
                  </tr>
                  <tr>
                    {MRmenu("/myPage/pointHistory", "포인트전환내역")}
                    {MRmenu("/myPage/setting", "회원정보수정")}
                  </tr>
                  {store.getState().user.isAuthenticated && (
                    <tr>
                      <td width="10%" align="center">
                        <a onClick={() =>{ openAside2(); onPopup()}}>
                          <span className="aside_btn1">로그아웃</span>
                        </a>
                      </td>
                      { (!isEmpty(store.getState().user.data) && store.getState().user.data.adminAllow) &&
                          <td width="10%" align="center">
                            <a onClick={getAdmin}>
                              <span className="aside_btn1">총판페이지</span>
                            </a>
                          </td>
                      }
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className={`header_wrap ${user.showleft ? "left" : ""}`}>
        <div className="top">
          <div className="m_logo">
            <Link to="/" onClick={() => onPath("/")}>
              <img src="../images/logo.png" width="130" alt="" />
            </Link>
          </div>
          <div className="m_menu1">
            <a onClick={openAside1}>
              <img src="../images/m_menu1.png" width="35" alt="" />
            </a>
          </div>
          <div className="m_menu2">
            <a onClick={openAside2}>
              <img src="../images/m_menu2.png" width="35" alt="" />
            </a>
          </div>
        </div>
        <div className="header_box">
          <div className="logo">
            <NavLink to="/" onClick={() => onPath("/")}>
              <img src="../images/logo.png" alt=""  style={{maxHeight : '100px'}}/>
            </NavLink>
          </div>
          <div className="game">
            <ul>
              {menus1.map((menu, index) => {
                return PCLmenu(menu, index);
              })}
            </ul>
          </div>
          <div className="gnb">
            <ul className="gnb_menus">
              {menus2.map((menu, index) => {
                return PCRmenu(menu, index);
              })}
              <li>
                { (!isEmpty(store.getState().user) && !isEmpty(store.getState().user.data) && (store.getState().user.data.adminAllow == true)) && <a className="navLink" onClick={getAdmin}>총판페이지</a>}
              </li>
            </ul>
          </div>
        </div>

        <div className="dialog" style={{display: popup ? "flex" : "none", backgroundColor:  !popup && '#00000000', transition: "0.5s", scale: popup ? "1" : "0"}}>
            <div className="container popup_color" style={{display: "block"}}>
                <div className="padding-20 d-flex"><img src="../images/question.png" style={{margin: "20px auto 0 auto"}} alt="" /></div>
                <div className="justify-center  d-flex betting_modal_text"><span style={{width: "100%", textAlign: "center"}}>로그 아웃하시겠습니까?</span></div>
                <div className=" d-flex w-100 justify-content-center padding-15 betting_modal_text">
                    <span className="popup-btn" onClick={onLogout}>네</span>
                    <span className="popup-btn" onClick={onPopup}>아니오</span>
                </div>
            </div>
        </div>
      </div>
      <div className={`z-index-99 modal-back show-left`} onClick={view}></div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated,
  gameCheck: state.page.gameCheck,
  user: state.user,
  showleft: state.user.showleft
});

export default connect(mapStateToProps, {logoutUser, SetShowLeft})(Headbar);



// WEBPACK FOOTER //
// ./src/components/Layout/Headbar.js